import { gql } from '@apollo/client';
import { deleteEmployeeTalk as deleteEmployeeTalkAction } from '@store/reducer/employeeTalksReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

const m = gql`
  mutation DeleteEmployeeTalk($id: Int!) {
    deleteEmployeeTalk(id: $id) {
      success
      message
    }
  }
`;

export default async function deleteEmployeeTalk(id: number): Promise<{ success: boolean; message: string }> {
    return GraphQL.mutate<{ success: boolean; message: string }>(m, { id }).then((data) => {
        if (data.success) {
            store.dispatch(deleteEmployeeTalkAction(id));
        }
        return data;
    });
}
